/*prettier-ignore*/
export let ABI = [{
  'inputs': [{
    'internalType': 'address',
    'name': '_storage',
    'type': 'address'
  }, { 'internalType': 'address', 'name': '_master', 'type': 'address' }, {
    'internalType': 'bytes32',
    'name': '_key',
    'type': 'bytes32'
  }, { 'internalType': 'address', 'name': '_relayHub', 'type': 'address' }],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'constructor'
}, {
  'anonymous': false,
  'inputs': [{
    'indexed': true,
    'internalType': 'address',
    'name': 'previousDeveloper',
    'type': 'address'
  }, { 'indexed': true, 'internalType': 'address', 'name': 'newDeveloper', 'type': 'address' }],
  'name': 'DeveloperTransferredEvent',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': false, 'internalType': 'address', 'name': 'addr', 'type': 'address' }, {
    'indexed': false,
    'internalType': 'uint256',
    'name': 'status',
    'type': 'uint256'
  }, { 'indexed': false, 'internalType': 'string', 'name': 'eventText', 'type': 'string' }],
  'name': 'MemberEvent',
  'type': 'event'
}, {
  'anonymous': false,
  'inputs': [{ 'indexed': false, 'internalType': 'address', 'name': 'addr', 'type': 'address' }, {
    'indexed': false,
    'internalType': 'uint256',
    'name': 'status',
    'type': 'uint256'
  }, { 'indexed': false, 'internalType': 'string', 'name': 'eventText', 'type': 'string' }],
  'name': 'WaitingEvent',
  'type': 'event'
}, {
  'constant': true,
  'inputs': [],
  'name': 'contractName',
  'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'contractVersion',
  'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'developer',
  'outputs': [{ 'internalType': 'addresspayable', 'name': '', 'type': 'address' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getHubAddr',
  'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getMessageData',
  'outputs': [{ 'internalType': 'bytes', 'name': '', 'type': 'bytes' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getRecipientBalance',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getSender',
  'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'address', 'name': 'origSender', 'type': 'address' }, {
    'internalType': 'bytes',
    'name': 'msgData',
    'type': 'bytes'
  }],
  'name': 'getSenderFromData',
  'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'bytes', 'name': 'context', 'type': 'bytes' }, {
    'internalType': 'bool',
    'name': 'success',
    'type': 'bool'
  }, { 'internalType': 'uint256', 'name': 'actualCharge', 'type': 'uint256' }, {
    'internalType': 'bytes32',
    'name': 'preRetVal',
    'type': 'bytes32'
  }],
  'name': 'postRelayedCall',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'bytes', 'name': 'context', 'type': 'bytes' }],
  'name': 'preRelayedCall',
  'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'addresspayable', 'name': 'newDeveloper', 'type': 'address' }],
  'name': 'transferDeveloper',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'contractIRelayHub', 'name': '_relayHub', 'type': 'address' }],
  'name': 'updateRelayHub',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [],
  'name': 'register',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [],
  'name': 'destroyContract',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'string', 'name': '_name', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_email',
    'type': 'string'
  }],
  'name': 'addFirstOwner',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }, {
    'internalType': 'string',
    'name': '_name',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_email', 'type': 'string' }],
  'name': 'addOwner',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }, {
    'internalType': 'string',
    'name': '_name',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_email', 'type': 'string' }, {
    'internalType': 'uint256',
    'name': '_value',
    'type': 'uint256'
  }],
  'name': 'initTreasuryWallet',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'string', 'name': '_name', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_email',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_pname', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_pdata',
    'type': 'string'
  }],
  'name': 'requestMembership',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'uint256', 'name': '_waitingId', 'type': 'uint256' }],
  'name': 'approveMembership',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'string', 'name': '_aname', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_adata',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_name', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_email',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_position', 'type': 'string' }],
  'name': 'updateMember',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'uint256', 'name': '_id', 'type': 'uint256' }],
  'name': 'getMember',
  'outputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }, {
    'internalType': 'string',
    'name': '_name',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_email', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_position',
    'type': 'string'
  }, { 'internalType': 'uint256', 'name': '_time', 'type': 'uint256' }, {
    'internalType': 'address',
    'name': '_approver',
    'type': 'address'
  }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }],
  'name': 'getMemberPic',
  'outputs': [{ 'internalType': 'string', 'name': '_aname', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_adata',
    'type': 'string'
  }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'string', 'name': '_aname', 'type': 'string' }, {
    'internalType': 'string',
    'name': '_adata',
    'type': 'string'
  }],
  'name': 'setMemberPic',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getMembers',
  'outputs': [{ 'internalType': 'address[]', 'name': '', 'type': 'address[]' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getMemberCounter',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }],
  'name': 'isMember',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'uint256', 'name': '_id', 'type': 'uint256' }],
  'name': 'getWaiting',
  'outputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }, {
    'internalType': 'string',
    'name': '_name',
    'type': 'string'
  }, { 'internalType': 'string', 'name': '_email', 'type': 'string' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getWaitingCounter',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'address', 'name': '_addr', 'type': 'address' }],
  'name': 'isWaiting',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getServiceKey',
  'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [],
  'name': 'getMemberKey',
  'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'address', 'name': 'addr', 'type': 'address' }, {
    'internalType': 'bytes32',
    'name': 'key',
    'type': 'bytes32'
  }],
  'name': 'isMemberKey',
  'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [],
  'name': 'generateServiceKey',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}, {
  'constant': true,
  'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }, {
    'internalType': 'address',
    'name': '',
    'type': 'address'
  }, { 'internalType': 'bytes', 'name': '', 'type': 'bytes' }, {
    'internalType': 'uint256',
    'name': '',
    'type': 'uint256'
  }, { 'internalType': 'uint256', 'name': '', 'type': 'uint256' }, {
    'internalType': 'uint256',
    'name': '',
    'type': 'uint256'
  }, { 'internalType': 'uint256', 'name': '', 'type': 'uint256' }, {
    'internalType': 'bytes',
    'name': '',
    'type': 'bytes'
  }, { 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
  'name': 'acceptRelayedCall',
  'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }, {
    'internalType': 'bytes',
    'name': '',
    'type': 'bytes'
  }],
  'payable': false,
  'stateMutability': 'view',
  'type': 'function'
}, {
  'constant': false,
  'inputs': [{ 'internalType': 'uint256', 'name': '_amount', 'type': 'uint256' }, {
    'internalType': 'addresspayable',
    'name': '_dest',
    'type': 'address'
  }],
  'name': 'withdrawFromRelayHub',
  'outputs': [],
  'payable': false,
  'stateMutability': 'nonpayable',
  'type': 'function'
}];
